var _BaseServiceV2 = require('./core/_BaseServiceV2');

module.exports = _BaseServiceV2.create('discovery', {
	searchProduct: {
		cache: 'productSearch',
		keyFunction: JSON.stringify.bind(JSON)
	},
	searchLibrary: {
		cache: 'librarySeach',
		keyFunction: JSON.stringify.bind(JSON)
	},
	getLibraryProductsByGenre: {
		cache: 'genreRecommendations',
		keyFunction: JSON.stringify.bind(JSON)
	},
	getLibraryProductsBySKF: {
		cache: 'skfRecommendations',
		keyFunction: JSON.stringify.bind(JSON)
	},
	getNewLibraryProducts: {
		cache: 'newStudentLibraryProducts'
	},
	getPopularLibraryProducts: {
		cache: 'popularStudentLibraryProducts'
	},
	findSimilars: {
		cache: 'findSimilars',
		keyProperty: 'q'
	}
});
